import { api } from "./client";
import type {
  Hero,
  LevelableSkill,
  PassiveTreeResponse,
  SkillName,
  SkillTreeResponse,
  HeroClass,
  HeroGender,
} from "../types";

export const heroApi = {
  getHero: () => api.get<Hero>("/hero"),

  createHero: (hero_class: HeroClass, gender: HeroGender, name: string) =>
    api.post<Hero>("/hero", { hero_class, gender, name }),

  renameHero: (name: string) => api.post<Hero>("/hero/rename", { name }),

  updateRotation: (rotation: SkillName[]) =>
    api.put<Hero>("/hero/rotation", { rotation }),

  updateAutoBattle: (body: {
    mode: string;
    prompt_on_start: boolean;
    tactical_skills: string[] | null;
  }) => api.put<Hero>("/hero/auto-battle", body),

  expandRotationSlots: () => api.post<Hero>("/hero/rotation/expand"),

  getSkillTree: (branch?: number) =>
    api.get<SkillTreeResponse>(
      branch === undefined ? "/hero/skills" : `/hero/skills?branch=${branch}`,
    ),

  upgradeSkill: (skillName: LevelableSkill, branch = 0) =>
    api.post<SkillTreeResponse>("/hero/skills/upgrade", {
      skill_name: skillName,
      branch,
    }),

  getPassiveTree: (branch?: number) =>
    api.get<PassiveTreeResponse>(
      branch === undefined ? "/hero/skills/passives" : `/hero/skills/passives?branch=${branch}`,
    ),

  upgradePassive: (passiveCode: string, branch = 0) =>
    api.post<PassiveTreeResponse>("/hero/skills/passives/upgrade", {
      passive_code: passiveCode,
      branch,
    }),

  selectSkillBranch: (branch: number) =>
    api.post<SkillTreeResponse>("/hero/skills/branch/select", { branch }),

  unlockSkillBranch: () => api.post<SkillTreeResponse>("/hero/skills/branch/unlock"),

  resetSkillBuild: () => api.post<SkillTreeResponse>("/hero/skills/reset"),
};
